<template>
    <div class="booking">
        <div class="container mx-auto">
            <reserve-same-appointment-failed />

            <NotifyOfPMI class="max-w-3xl mx-auto"/>

            <patient-details v-if="currentTab === 'details'" />

            <injury-details v-if="currentTab === 'injury'" />

            <payment-details v-if="currentTab === 'payment'" />
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    import InjuryDetails from '../components/Checkout/InjuryDetails';
    import NotifyOfPMI from '../components/Global/NotifyOfPMI';
    import PatientDetails from '../components/Checkout/PatientDetails';
    import PaymentDetails from '../components/Checkout/PaymentDetails';
    import ReserveSameAppointmentFailed from '../components/Appointments/ReserveSameAppointmentFailed';

    export default {
        name: 'booking',

        components: {
            InjuryDetails,
            NotifyOfPMI,
            PatientDetails,
            PaymentDetails,
            ReserveSameAppointmentFailed,
        },

        computed: mapState('appointment', ['appointmentData']),

        data() {
            return {
                currentTab: 'details',
            };
        },

        mounted() {
            if (this.appointmentData === null) {
                this.$router.push({ name: 'home' });
            }

            this.showNavigation();

            this.setTheme('light');

            this.showComponent({
                name: 'tabs',
                props: {
                    active: this.currentTab,
                }
            });

            this.setFooterMessage(null);

            this.listen('checkout.tab', this.setTab);
        },

        destroyed() {
            this.silence('checkout.tab', this.setTab);
        },

        methods: {
            ...mapActions('header', [
                'showComponent',
                'showNavigation',
                'setTheme',
            ]),

            ...mapActions('checkout', [
                'setPaymentDetails',
                'setPaymentDetailsInvalid',
            ]),

            setTab(tab) {
                this.$set(this, 'currentTab', tab);
            },
        },
    }
</script>
